import { cn, emptyFragment, Modal, ModalBody, useOpenable } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { dataLayerUpdate } from '../../../../../../components/Tooling/GoogleTagManagerTooling/Loader';
import { ExperienceDictionaryEntryResponse } from '../../../../../ExperiencesDictionary/Types';
import ExperienceVideoThumbnail from './ExperienceVideoThumbnail';
import ModalState from './ModalState';

interface Props {
  className?: string;
  title: string;
  thumbnail: string;
  experienceResource: ExperienceDictionaryEntryResponse;
}

function ExperienceVideoDetails({ className, title, thumbnail, experienceResource }: Props) {
  const { isOpen, onOpen, onClose } = useOpenable();

  const openVideo = () => {
    dataLayerUpdate({ event: 'discovery-portal-video-open', videoTitle: title });
    onOpen();
  };

  return (
    <>
      <ExperienceVideoThumbnail
        className={className}
        alt={title}
        src={thumbnail}
        onClick={openVideo}
      />
      <Modal
        className="h-150 rounded"
        open={isOpen}
        classNames={{
          closeButton: 'left-5 md:left-auto right-5',
        }}
        size="5xl"
        onClose={onClose}
      >
        <ModalBody
          className={cn(
            'w-full px-0 pb-0 pt-14 sm:px-0 sm:pb-0 sm:pt-14',
            'grid grid-cols-[auto_19.875rem]',
          )}
        >
          {experienceResource.links.overviewVideo
            .map((link) => <ModalState experienceResource={experienceResource} link={link} />)
            .getOrElse(emptyFragment)}
        </ModalBody>
      </Modal>
    </>
  );
}

export default observer(ExperienceVideoDetails);
